module.exports = __webpack_public_path__ + "static/media/C (1).88fc3296.jpg";